
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { useState } from "react";
import { ClientForm } from "./ClientForm";

interface EditClientDialogProps {
  clientId: string;
  initialValues: {
    school_id: string;
    nama_sekolah: string;
  };
  onClientUpdated: () => void;
}

export const EditClientDialog = ({ clientId, initialValues, onClientUpdated }: EditClientDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon">
          <Pencil className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit School</DialogTitle>
        </DialogHeader>
        <ClientForm
          mode="edit"
          clientId={clientId}
          initialValues={initialValues}
          onSuccess={() => {
            onClientUpdated();
            setOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
